import RichContentTitle from './RichContentTitle'

export default RichContentTitle
